import { render, staticRenderFns } from "./video-index.vue?vue&type=template&id=b8361eb2&scoped=true&"
import script from "./video-index.vue?vue&type=script&lang=js&"
export * from "./video-index.vue?vue&type=script&lang=js&"
import style0 from "./video-index.vue?vue&type=style&index=0&id=b8361eb2&prod&lang=css&"
import style1 from "./video-index.vue?vue&type=style&index=1&id=b8361eb2&prod&scoped=true&lang=css&"
import style2 from "./video-index.vue?vue&type=style&index=2&id=b8361eb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8361eb2",
  null
  
)

export default component.exports